import { render, staticRenderFns } from "./bigImg.vue?vue&type=template&id=bdc0d806&scoped=true&"
import script from "./bigImg.vue?vue&type=script&lang=js&"
export * from "./bigImg.vue?vue&type=script&lang=js&"
import style0 from "./bigImg.vue?vue&type=style&index=0&id=bdc0d806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc0d806",
  null
  
)

export default component.exports